import * as React from 'react';
export const Dropdown = props => {
    const handleChange = (event) => {
        props.onClick(event.target.value);
    };
    return (React.createElement("div", { className: props.className }, !props.asPlainText ? (React.createElement("select", { onChange: handleChange, value: props.value }, props.elements.map((element, index) => (React.createElement("option", { value: element.id, disabled: !element.isActive, key: index }, element.text))))) : props.children ? (props.children) : ('')));
};
